import React from "react";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Portfolio from "../components/Portfolio";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <SEO page="home" />
      <Header />
      <Hero />
      <Features />
      <Portfolio />
      <Footer />
    </>
  );
};

export default Home;